import { Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { StartupChecksBanner } from './StartupChecksBanner';

const { Content } = Layout;

export const MainLayout: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar />
      <Layout style={{ marginLeft: 250 }}>
        <Header />
        <Content style={{ margin: '24px', overflow: 'initial' }}>
          <StartupChecksBanner />
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
};
